import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UserSelectQaService } from '../../../core/services/user-select-qa.service';
import { IUserSelectQaCode } from '../../../core/interfaces/user-select-qa';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-select-qa',
  imports: [CommonModule, ReactiveFormsModule, NzTableModule],
  templateUrl: './user-select-qa.component.html',
  styleUrls: ['./user-select-qa.component.less'],
})
export class UserSelectQaComponent implements OnInit, OnDestroy {
  form: FormGroup;
  itemForm: FormGroup;
  items: IUserSelectQaCode[] = [];
  isHovered: boolean[] = [];
  showPopup = false;
  selectedItems: IUserSelectQaCode[] = [];
  selectedQACodes: string[] = [];
  preSelectedCodes: string[] = [];
  isLoading = false;
  hasError = false;

  getAllListSubscription!: Subscription;

  constructor(
    private readonly fb: FormBuilder,
    private readonly userSelectQaService: UserSelectQaService,
    private readonly route: ActivatedRoute
  ) {
    this.form = this.fb.group({
      HdItemAmount: [''],
      DoAction: [''],
    });

    this.itemForm = this.fb.group({
      ItemQa: [''],
    });
  }

  ngOnInit(): void {
    this.loadItems();
    this.loadPreSelectedCodes();
  }

  loadPreSelectedCodes(): void {
    const preSelected = this.route.snapshot.queryParamMap.get('preSelected');
    if (preSelected) {
      this.preSelectedCodes = preSelected
        .split(',')
        .map((code) => code.trim())
        .filter((code) => code);
      this.selectedQACodes = [...this.preSelectedCodes];
    }
  }

  loadItems() {
    this.isLoading = true;
    this.hasError = false;

    this.getAllListSubscription = this.userSelectQaService
      .getAllList()
      .subscribe({
        next: (res) => {
          let data = res.body;
          this.items = data || [];
          this.isHovered = new Array(this.items.length).fill(false);
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading QA items:', error);
          this.items = [];
          this.isHovered = [];
          this.isLoading = false;
          this.hasError = true;
        },
      });
  }

  retryLoadItems(): void {
    this.loadItems();
  }

  toggleSelection(item: IUserSelectQaCode): void {
    const index = this.selectedItems.indexOf(item);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
  }

  submitSelection(): void {
    if (this.selectedItems.length < 1) {
      alert('You did not select any QA.');
      return;
    }
  }

  onMouseOver(index?: number): void {
    if (index !== undefined) {
      this.isHovered[index] = true;
    }
  }

  onMouseOut(index: number): void {
    this.isHovered[index] = false;
  }

  goAddQA(): void {
    const qa_select: string[] = [];
    const qa = document.getElementsByTagName('input');

    for (let i = 0; i < qa.length; i++) {
      if (qa.item(i)?.type === 'checkbox' && qa.item(i)?.checked) {
        qa_select.push(qa.item(i)?.value || '');
      }
    }

    if (qa_select.length < 1) {
      alert('You did not select any QA.');
      return;
    }

    const qaString = qa_select.join(', ');

    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'QA_SELECTION',
          selectedQACodes: qaString,
        },
        window.location.origin
      );
      window.close();
    } else {
      console.log(`Selected QA codes: ${qaString}`);
    }
  }

  checkQA(code: string): boolean {
    return this.preSelectedCodes.includes(code);
  }

  ngOnDestroy(): void {
    this.getAllListSubscription?.unsubscribe();
  }
}
